import { windowPopup } from 'window-popup'

const MobileLink = ({ href, children: link }) => {
  function openPopup(e) {
    e.preventDefault()
    windowPopup(375, 640, href, 'Savibook')
  }

  return (
    <a href={href} onClick={openPopup} style={{ whiteSpace: 'nowrap' }}>
      {link}
    </a>
  )
}

export default MobileLink
